module.exports = __webpack_public_path__ + "static/media/june2024-1.de21a20b.webp";